import { render, staticRenderFns } from "./VesselEquipmentBaseStations.vue?vue&type=template&id=8ef9efb6&"
import script from "./VesselEquipmentBaseStations.vue?vue&type=script&lang=js&"
export * from "./VesselEquipmentBaseStations.vue?vue&type=script&lang=js&"
import style0 from "./VesselEquipmentBaseStations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports